class Strings {
  /// NO PAGE
  static noPage = "404 No page";

  /// NEWS SECTION
  static newsTitleFirst = "Fresh air. ";
  static newsTitleBlue = "Fresh updates.";
  static upsteer =
    "​The UpSteer by Asseco blog post introduces Appara, a startup focused on digitizing and automating legal and corporate governance processes.";
  static upsteerDate = "Mar 6, 2024";
  static medilink =
    "Medilink Midlands brought together over 250 professionals from the life sciences and medtech sectors for a day of networking";
  static medilinkDate = "Oct 03, 2024";
  static upsteerAsseco =
    "At UpSteer 2024, Asseco recognized Appara among four innovative startups for its smart face mask that monitors air quality and health metrics";
  static upsteerAssecoDate = "Nov 26, 2024";
  static inphoVenture =
    "​At the INPHO Venture Summit 2024 in Bordeaux, Appara was collected a great feedback and could compare with a bigger companies";
  static inphoVentureDate = "Oct 24, 2024";
  static itapa = `​At Jesenná ITAPA 2024, Appara presented on smart biomonitoring during sports activities and environmental health technologies.`;
  static itapaDate = "Nov 28, 2024";
  static medilinkHive = `​Appara Technologies participated in Medilink Midlands' inaugural Innovation HIVE. Receiving expert support on scaling and investment readiness`;
  static medilinkHiveDate = "Apr 3, 2025";
  static rioEvent = `​Appara is thrilled to participate in Rio Web Summit 2025, where over 34,000 attendees, 1,000+ startups, and 500+ investors will gather`;
  static rioEventDate = "Apr 27, 2025";
  static EuFundDate = "May 5, 2025";
  static EuFund =
    "APPARA has been co-funded by the European Union under the Innovation Voucher scheme to advance the development of the APPARA face mask.";
  static EuFundLink = "More information";

  /// CALCULATOR SECTION
  static airQualityTitle = "Air quality calculator";
  static airQualitySubtitle = `Air quality significantly impacts outdoor exercise performance and health. High levels
            of air pollution can lead to reduced lung function, increased fatigue, and long-term
            respiratory issues, especially for those with asthma or cardiovascular conditions. Poor
            air quality may also cause throat irritation, dizziness, and inflammation, making
            workouts feel more strenuous. The Appara Air Quality Calculator helps you avoid these
            risks by suggesting optimal workout times and alternative locations with cleaner air.
            Whether training for endurance or simply going for a run, this tool empowers individuals
            to make informed decisions, protecting their health while staying active outdoors.`;
  static city = "City";
  static seoul = "Seoul";
  static hongKong = "Hong Kong";
  static kualaLumpur = "Kuala Lumpur";
  static singapour = "Singapour";
  static jakarta = "Jakarta";
  static rioDeJaneiro = "Rio de Janeiro";
  static mexicoCity = "Mexico City";
  static tokyo = "Tokyo";
  static beijing = "Beijing";
  static airQualityBtn = "Get the air quality";
  static againBtn = "Test again";
  static airQualityIn = "The air quality in ";
  static is = " is ";
  static workoutActivity = "One workout activity in this city, equals to ";
  static cigarettesText = " smoked cigarettes. This means ";
  static cigarettesWeek = " cigarettes in a week, ";
  static cigarettesMonth = " cigarettes in a month and, ";
  static cigarettesYear = " in a year. ";
  static joinApparaProducts = "Join Appara waiting list for our products ";

  /// CONTACT US SECTION
  static bannerSuccess = "✅ Email send sucessfully";
  static bannerError = "❌ Error Email wasn't send";
  static contactUsTitle = "Want to test the gear? Partner up? Just curious?";
  static contactInfoTitle = "Contact information";
  static contactUsPhone = "+421 915 478 240";
  static contactUsEmail = "dominik.kadlubiak@appara.eu";
  static contactUsNameLabel = "First name";
  static contactUsNamePlaceholder = "Enter your name";
  static contactUsSurnameLabel = "Last name";
  static contactUsSurnamePlaceholder = "Enter your last name";
  static contactUsEmailLabel = "E-mail";
  static contactUsEmailPlaceholder = "Enter your e-mail";
  static contactUsPhoneLabel = "Phone number";
  static contactUsPhonePlaceholder = "+00 000 000";
  static contactUsInquiry = "General inquiry";
  static contactUsMeeting = "Meeting";
  static contactUsConsult = "Consultation";
  static contactUsOther = "Other";
  static contactUsCalendly = "Select date and time";
  static contactUsCalendlyBtn = "Book with Calendly";
  static contactUsMessageLabel = "Message";
  static contactUsMessagePlaceholder = "Enter your message...";
  static contactUsSendBtn = "Send";

  /// FOOTER SECTION
  static footerSocialsTitle = "Social";
  static footerLinkedIn = "LinkedIn";
  static footerInstagram = "Instagram";
  static footerOurProducts = "Our products";
  static footerCalculator = "Air quality calculator";
  static footerContacts = "Contacts";
  static footerInquiry = "General inquiry";
  static footerMeeting = "Meeting";
  static footerConsult = "Consultation";
  static footerOther = "Other";
  static footerTnC = "Terms & Conditions";

  /// HERO SECTION
  static heroTitle = "You move with purpose. Now choose the air that moves with you.";
  static heroSubtitle =
    "Breathing tech for runners, riders and anyone chasing performance in the city.";
  static heroJoinBtn = "Choose what you breathe";

  /// MASK SECTION
  static maskCleanOne = "Breathe clean.";
  static maskCleanTwo = "Perform better.";
  static maskCleanSubtitle =
    "Built for movement. Designed to block what doesn’t belong in your lungs like fine dust, pollutants and allergens without slowing you down.";
  static maskTakeControllOne =
    "Durable. Reusable. Made to move. High-performance filters that fight pollution and fit your lifestyle.";
  static maskEngineredTitle = "Secure fit. Light feel. Built to keep up wherever you train.";
  static maskCityBuildTitle =
    "Style meets substance. Urban-ready gear with serious protection that moves with you.";
  static maskTryFaceMask =
    "Want to try the Appara mask? Join the waitlist for exclusive early access and personal fitting options.";
  static maskCityBuildBtn = "Learn more";
  static maskInterestedBtn = "Join the waiting list";

  /// MOBILE APP SECTION
  static mobileControllOne = "Stay in control.";
  static mobileControllTwo = "Wherever you go.";
  static mobileControllSubtitle =
    "Track your exposure. Know your routes. Get smarter with every breath. Future versions will sync with the mask.";
  static mobileApparaTitle =
    "Real-time air insights. Smarter workouts. Personalized breathing data that puts your health in your hands.";
  static mobileMonitorAirTitle =
    "Know what’s in your lungs before it slows you down. Real-time data helps you train cleaner and smarter.";
  static mobileActivitiesTitle =
    "From smog to sun — breathe better by knowing where and when to move.";
  static mobileInterested =
    "Want to breathe smarter? Join the waiting list for early access to the Appara app and exclusive insights.";
  static mobileInterestedBtn = "Join the waiting list";
  static mobileStayControllOne = "Stay in control.";
  static mobileStayControllTwo = "Wherever you go.";
  static mobileInterestedInApparaBtn = "Join the waiting list";

  /// PRODUCTS SECTION
  static productsSuccess = "✅ Email send sucessfully";
  static productsFail = "❌ Error Email wasn't send";
  static productsJoinListTitle = "Join the waiting list for our products";
  static productsJoinListSubtitle = "What are you interested in?";
  static productsFaceMask = "Face mask";
  static productsMobileApp = "Appara Mobile app";
  static productsFirstNameLabel = "First name";
  static productsFirstNamePlaceholder = "Enter your name";
  static productsLastNameLabel = "Last name";
  static productsLastNamePlaceholder = "Enter your last name";
  static productsEmailLabel = "E-mail";
  static productsEmailPlaceholder = "Enter your e-mail";
  static productsTncTitle = "Accept ";
  static productsTncSubtitle = "terms and conditions";
  static productsMarketing = "Consent marketing & newsletter";
  static productsConfirmBtn = "Confirm";
  static productsSuccessTitle = "Waitlist successfully joined";
  static productsSuccessSubtitleOne =
    "Thank you for joining our waitlist, your request has been submitted. You will receive a confirmation e-mail shortly.";
  static productsSuccessButton = "Keep exploring";
}

export default Strings;
